import React from "react";
import { Sparkles } from "lucide-react";
import SolutionCard from "./cards/SolutionCard";

const OtherSolutions = () => {
  return (
    <SolutionCard
      icon={Sparkles}
      title="Custom Solutions"
      subtitle="Specialized RL Partnerships"
      description="Partner with us to achieve state-of-the-art results for your specific task!"
    >
      <p className="text-muted-foreground mt-1">
        We've implemented many custom RL solutions and are excited to dive into
        your use case. Be the first to pioneer RL for your industry!
      </p>
    </SolutionCard>
  );
};

export default OtherSolutions;
